var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final PIX"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 1256,
    transform: "translate(-860 -882)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "2 - resumo"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 830,
    height: 976,
    transform: "translate(-519 -762)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 27626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cobran\xC3\xA7a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7495 2.916C11.6495 2.56223 11.4367 2.25079 11.1435 2.02904C10.8503 1.80729 10.4926 1.68736 10.125 1.6875H7.875C7.1025 1.6875 6.45 2.20725 6.2505 2.916M11.7495 2.916C11.7908 3.0615 11.8125 3.216 11.8125 3.375C11.8125 3.52418 11.7532 3.66726 11.6477 3.77275C11.5423 3.87824 11.3992 3.9375 11.25 3.9375H6.75C6.60082 3.9375 6.45774 3.87824 6.35225 3.77275C6.24676 3.66726 6.1875 3.52418 6.1875 3.375C6.1875 3.216 6.21 3.0615 6.2505 2.916M11.7495 2.916C12.234 2.95275 12.7155 2.9985 13.1948 3.054C14.0198 3.15 14.625 3.86175 14.625 4.69275V14.625C14.625 15.0726 14.4472 15.5018 14.1307 15.8182C13.8143 16.1347 13.3851 16.3125 12.9375 16.3125H5.0625C4.61495 16.3125 4.18573 16.1347 3.86926 15.8182C3.55279 15.5018 3.375 15.0726 3.375 14.625V4.69275C3.375 3.86175 3.9795 3.15 4.80525 3.054C5.28603 2.99833 5.76787 2.95232 6.2505 2.916",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.be26dfe93847b65c100c105000e482e7.svg";
export { ForwardRef as ReactComponent };